module.exports = __webpack_public_path__ + "img/zhuti-02.2e626471.png";